import Color from './Color'

const SERVICE_STATE_LIST = {
  277670000: {
    title: '新規申込み中',
    color: `${Color.FONT.MENU_DARK}`,
  },
  277670003: {
    title: '契約中',
    color: `${Color.FONT.MENU_DARK}`,
  },
  277670005: {
    title: '契約満了',
    color: 'white',
    bg: `${Color.FONT.MENU_DARK}`,
    orgTitle: '契約期間満了',
  },
  277670006: {
    title: '解約',
    color: 'white',
    bg: `${Color.FONT.MENU_DARK}`,
    orgTitle: '合意解約',
  },
  277670007: {
    title: '解約',
    color: 'white',
    bg: `${Color.FONT.MENU_DARK}`,
    orgTitle: '事故解約',
  },
}

export default SERVICE_STATE_LIST
